// extracted by css-extract-rspack-plugin
export default {"userSelect":"tlp7y0K8wbcZcOUs__userSelect___","roleList":"trS0jMn33g8EVhb8__roleList___","roleSelect":"iV_QGOKB80MFEe6m__roleSelect___"};